export default __webpack_public_path__ + "static/media/lobby_third_image.16e54a9b.jpg";